import { FC } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { cn } from '../../lib/utils'

interface DocumentBodyProps {
  content: string
  className?: string
}

/** Shared clinical-manuscript markdown renderer (view mode). */
export const DocumentBody: FC<DocumentBodyProps> = ({ content, className }) => (
  <article
    className={cn(
      'prose prose-sm max-w-none dark:prose-invert',
      'prose-headings:font-display prose-headings:tracking-tight',
      'prose-h1:text-2xl prose-h1:font-semibold prose-h1:border-b prose-h1:border-border/30 prose-h1:pb-2 prose-h1:mt-6 prose-h1:mb-3',
      'prose-h2:text-xl prose-h2:font-semibold prose-h2:mt-5 prose-h2:mb-2',
      'prose-h3:text-lg prose-h3:font-medium prose-h3:mt-4 prose-h3:mb-2',
      'prose-p:my-3 prose-p:leading-relaxed',
      '[&_ul]:list-disc [&_ul]:pl-5 [&_ul]:my-3',
      '[&_ol]:list-decimal [&_ol]:pl-5 [&_ol]:my-3',
      '[&_li]:my-1',
      '[&_li::marker]:text-clinical-teal [&_li::marker]:font-medium',
      'prose-blockquote:border-l-2 prose-blockquote:border-clinical-teal/40',
      'prose-blockquote:pl-4 prose-blockquote:my-4',
      'prose-blockquote:text-muted-foreground prose-blockquote:italic',
      'prose-code:font-mono prose-code:text-sm',
      'prose-code:bg-muted/50 prose-code:px-1.5 prose-code:py-0.5',
      'prose-code:rounded prose-code:text-clinical-teal',
      'prose-code:before:content-none prose-code:after:content-none',
      'prose-a:text-primary prose-a:no-underline hover:prose-a:underline',
      'prose-hr:my-6 prose-hr:border-border/50',
      className,
    )}
  >
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{typeof content === 'string' ? content : ''}</ReactMarkdown>
  </article>
)
